export default "__VITE_ASSET__CRyaAJfE__"